import React, { useEffect, useState, useRef } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { OTPFormField } from "../components/otp/OTPFormField/OTPFormField";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "@components/buttons/CustomButton";
import SignUpNoise from "@assets/noise/signup-noise.png";
import secureLocalStorage from "react-secure-storage";
import InputDiv from "../components/InputDiv";
import SignUpCarousel from "../components/carousel/SignUpCarousel";
import LightCustomButton from "@components/buttons/LightCustomButton";
import { authenticationApiService } from "@services/apis/Authentication";

const VerifyOtp = () => {
  const methods = useForm({
    defaultValues: {
      otp: Array(6).fill(""), // Default value for the otp field
    },
  });

  const [showError, setShowError] = useState<boolean>(false);

  const navigate = useNavigate();
  const marketingDataString = sessionStorage.getItem("marketingData");
  const marketingData = marketingDataString
    ? JSON.parse(marketingDataString)
    : "";

  console.log("marketingData", marketingData);
  const location = useLocation();
  let email = (location.state as { email?: string })?.email ?? "";
  let csrfToken = (location.state as { csrfToken?: string })?.csrfToken ?? "";
  console.log("email", email);
  console.log("csrfToken", csrfToken);

  const loginEmail = email ? secureLocalStorage.getItem("loginEmail") : "";
  const loginCsrfToken = csrfToken
    ? secureLocalStorage.getItem("loginCsrfToken")
    : "";

  console.log("loginEmail", loginEmail);
  console.log("loginCsrfToken", loginCsrfToken);

  useEffect(() => {
    if (!loginEmail || !loginCsrfToken) {
      navigate("/login");
    }
  }, [loginEmail, loginCsrfToken, navigate]);
  const validLoginCsrfToken =
    typeof loginCsrfToken === "string" ? loginCsrfToken : "";

  const [token, setToken] = useState<string>(validLoginCsrfToken || csrfToken);

  const continueButtonRef = useRef<HTMLButtonElement>(null);
  const [seconds, setSeconds] = useState(30);
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);
  const timeSetting = () => {
    // Clear any existing interval when setting a new one
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds <= 1) {
          clearInterval(interval); // Clear interval when reaching 0
          return 0; // Set seconds to 0 and stop
        }
        return prevSeconds - 1;
      });
    }, 1000);

    // Return the interval ID to clear it later if needed
    return interval;
  };

  useEffect(() => {
    const interval = timeSetting();

    // Cleanup the interval on component unmount or when re-renders
    return () => clearInterval(interval);
  }, []);

  const handleResendClick = () => {
    console.log("click");

    // Clear OTP fields
    methods.reset({
      otp: Array(6).fill(""), // Reset OTP to an array of empty strings
    });

    // Clear any existing OTP errors
    clearErrors("otp");

    // Reset the timer
    setSeconds(30);
    timeSetting();
    handleResend();
  };

  const {
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
  } = methods;

  // Function to handle form submit
  const onSubmit = async (data: { otp: any[] }) => {
    setIsButtonLoading(true);

    const code = data.otp.join("");
    console.log("code", code);

    try {
      const response = await authenticationApiService.verifyOtp(
        email,
        code,
        token
      );
      console.log("verify otp response", response);
      secureLocalStorage.setItem("jwt", response.data.jwt);
      console.log("login successful");
      secureLocalStorage.removeItem("loginEmail");
      secureLocalStorage.removeItem("loginCsrfToken");
      navigate("/");
      window.location.reload();
    } catch (error: any) {
      console.log("error is", error.response.data);
      const msg = error.response.data.msg;
      if (msg === "Access Denied!") {
        navigate("/error");
      } else {
        handleSetOtpErrorMessage("Incorrect OTP. Please try again");
      }
    } finally {
      setIsButtonLoading(false);
    }
  };

  // Optional: handle error messages for OTP from within OTPFormField
  const handleSetOtpErrorMessage = (message: any) => {
    if (message) {
      setError("otp", {
        type: "manual",
        message,
      });
    } else {
      clearErrors("otp");
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      continueButtonRef.current?.click();
    }
  };

  const checkValidOtp = () => {
    const data = methods.getValues();
    console.log("data", data);
    const code = data.otp.join("");
    return code.length === 6;
  };

  const handleResend = async () => {
    setIsButtonLoading(true);

    try {
      const data = await authenticationApiService.sendOtp(email);
      console.log("csrf", data.data.csrfToken);
      setToken(data.data.csrfToken);
      // localStorage.setItem("loginCsrfToken", data.data.csrfToken);
    } catch (error: any) {
      console.error("Failed to resend OTP:", error);
    } finally {
      setIsButtonLoading(false);
    }
  };

  const checkLogin = () => {
    const jwt = secureLocalStorage.getItem("jwt");
    if (jwt) {
      navigate("/");
    }
  };

  useEffect(() => {
    checkLogin();
  }, []);

  return (
    <div
      className="bg-bg-button-secondary h-[100dvh] flex flex-col bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${SignUpNoise})` }}
    >
      <div className="h-[60dvh]">
        <SignUpCarousel />
      </div>
      <div className="flex flex-col flex-grow">
        <InputDiv
          text="Verify your email-id"
          backButton={true}
          onClick={() => navigate("/login")}
        >
          <div className="text-text-base text-[14px] mt-4 font-normal mb-4">
            Enter the verification code we’ve sent to your email ID
            <br />
            {email}.
          </div>
          <div className="border-[0.5px] border-border-table"></div>

          <FormProvider {...methods}>
            <form onKeyDown={handleKeyDown}>
              <OTPFormField
                name="otp"
                onSetOtpErrorMessage={handleSetOtpErrorMessage}
                length={6}
                errorMessage={errors.otp && errors.otp.message}
              />
              <div className="flex justify-between items-center mt-3">
                <span className="text-[12px] font-light">
                  Enter OTP in{" "}
                  <span className="text-text-brand-alt font-semibold text-[14px]">
                    {seconds}s
                  </span>
                </span>
                <LightCustomButton
                  text="REGENERATE OTP"
                  onClick={handleResendClick}
                  isActive={seconds <= 0}
                  isButtonLoading={isButtonLoading}
                />
              </div>
            </form>
          </FormProvider>
          <div className="mt-7 my-4">
            <CustomButton
              ref={continueButtonRef}
              text="SUBMIT"
              onClick={handleSubmit(onSubmit)}
              isActive={checkValidOtp()}
              isButtonLoading={isButtonLoading}
            />
          </div>
        </InputDiv>
      </div>
    </div>
  );
};

export default VerifyOtp;
